import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

// salesonepro
import { ModalPopupOverlayRef } from '@salesonepro/components';
import { ApiService, ToasterService } from '@salesonepro/services';
import { ValidationErrorsComponent } from '@salesonepro/components/validation-error/validation-error.component';
import { ServerValidationErrorComponent } from '@salesonepro/components/server-validation-error/server-validation-error.component';
import { SpinnerDirective } from '@salesonepro/modules/spinner/spinner.directive';
import { IconComponent } from '@salesonepro/components/icon/icon.component';
import { CustomValidator, passwordValidator } from '@salesonepro/custom-validator';

@Component({
  selector: 'app-imported-user-setup',
  templateUrl: './imported-user-setup.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    ServerValidationErrorComponent,
    SpinnerDirective,
    IconComponent
  ]
})
export class ImportedUserSetupComponent {
  private fb = inject(FormBuilder);
  private apiService = inject(ApiService);
  private toastr = inject(ToasterService);
  private modalRef = inject(ModalPopupOverlayRef);

  setupForm: FormGroup;
  isSubmitting = false;
  isFormSubmitted = false;
  serverErrors: any = null;

  constructor() {
    this.initializeForm();
  }

  private initializeForm(): void {
    this.setupForm = this.fb.group({
      email: ['', [
        Validators.required,
        Validators.email
      ]],
      current_password: ['', [Validators.required]],
      new_password: ['', [Validators.required, CustomValidator.noWhitespace, passwordValidator()]],
    });
  }


  onSubmit(): void {
    this.isFormSubmitted = true;
    this.serverErrors = null;

    if (this.setupForm.valid) {
      this.isSubmitting = true;
      this.apiService.post('/account/set_imported_user', this.setupForm.value).subscribe({
        next: (response) => {
          this.toastr.success('Account setup completed successfully!');
          this.modalRef.close({ success: true, data: response });
        },
        error: (error) => {
          this.isSubmitting = false;
          this.serverErrors = error;
          if (error?.non_field_errors?.length) {
            this.toastr.error(error.non_field_errors);
          }
        }
      });
    } else {
      // Focus on first invalid field
      const firstInvalidField = document.querySelector('.ng-invalid:not(form)') as HTMLElement;
      if (firstInvalidField) {
        firstInvalidField.focus();
        firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  onCancel(): void {
    this.modalRef.close({ success: false });
  }
}